import { SubscriptionManager } from "../SubscriptionManager";

/**
 * 加密货币价格订阅管理器
 */
export class CryptoPriceSubscriptionManager extends SubscriptionManager<string> {
    protected buildSubscribeMessage( symbol: string ) {
        return { type: "subscribe", symbolId: symbol };
    }

    protected buildUnsubscribeMessage( symbol: string ) {
        return { type: "unsubscribe" };
    }

    protected extractSubscriptionId( data: any ): string | undefined {
        return data?.type === "subscribed" ? data?.symbolId : undefined;
    }
}
